import { GridRenderCellParams, GridValidRowModel } from '@mui/x-data-grid-pro'
import { Indicator, IndicatorStatus } from '../../components/indicator'

type Params = GridRenderCellParams<GridValidRowModel, StockRenderProps>

export type StockRenderProps = {
  total?: number
  threshold?: number
}

const resolveIndicatorStatus = (
  total: number,
  threshold?: number,
): IndicatorStatus => {
  if (total <= 0) {
    return IndicatorStatus.Red
  }

  if (threshold && total <= threshold) {
    return IndicatorStatus.Yellow
  }

  return IndicatorStatus.Green
}

export const StockRenderer = (params: Params) => {
  const { id, field, value } = params

  if (!value) {
    return
  }

  const { threshold, total } = value

  if (total === undefined) return null

  return (
    <div
      className="MuiDataGrid-cellContent"
      data-testid={`string-field-${id}-${field}`}
    >
      <Indicator status={resolveIndicatorStatus(total, threshold)}>
        {total}
      </Indicator>
    </div>
  )
}
